var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThemeMoonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80704 0.938477C4.90189 0.938643 4.01376 1.18451 3.2374 1.64986C2.46103 2.1152 1.82555 2.78257 1.39874 3.58077C0.971921 4.37897 0.769787 5.27805 0.813894 6.18212C0.858001 7.08619 1.1467 7.96134 1.64918 8.7142C2.15167 9.46706 2.8491 10.0694 3.66708 10.457C4.48505 10.8445 5.39289 11.0028 6.29376 10.9148C7.19462 10.8269 8.05472 10.496 8.78229 9.95759C9.50987 9.41915 10.0776 8.6933 10.425 7.85748C10.5955 7.44748 10.187 7.03548 9.77604 7.20248C9.07162 7.48781 8.28949 7.51726 7.56562 7.28569C6.84174 7.05412 6.22192 6.57619 5.81391 5.93499C5.4059 5.29378 5.2355 4.52987 5.33236 3.77605C5.42921 3.02224 5.78718 2.32621 6.34404 1.80898L6.38254 1.76898C6.65804 1.45398 6.43904 0.942477 6.00354 0.942477H5.87054L5.83654 0.939477L5.80654 0.938477H5.80704Z",
    fill: "#3E3E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeMoonIcon);
export default __webpack_public_path__ + "static/media/theme-moon-icon.6d98cf0120f9bd8206f0193aac082af1.svg";
export { ForwardRef as ReactComponent };